import { render, staticRenderFns } from "./svgThreads.vue?vue&type=template&id=5010c8cc&scoped=true"
import script from "./svgThreads.vue?vue&type=script&lang=js"
export * from "./svgThreads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5010c8cc",
  null
  
)

export default component.exports